import { makeStyles } from '@eagleview/ev-comp-library';

/**
 * Styling associated Sign up component
 */
export default makeStyles((theme) => ({
  '@global': {
    '.am-MuiFormHelperText-root.Mui-error': {
      fontWeight: 'bold',
    },
    '.am-MuiFormLabel-root.Mui-error': {
      color: '#BC1616 !important',
    },
    '.am-MuiFormLabel-asterisk.Mui-error': {
      color: '#BC1616 !important',
    },
  },
  topContainer: {
    position: 'relative',
    minHeight: '90%',
    flex: 1,
    '@media (max-width:675px)': {
      height: 'fit-content',
    },
  },
  backdrop: {
    color: '#fff',
    zIndex: theme.zIndex.drawer + 1,
  },
  errorContainer: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    borderBottom: '#BC1616',
    background: '#FFCDD1',
  },
  messageContainer: {
    border: '2px #cdb21f solid',
    background: '#feffce url("https://my.eagleview.com/images/warning-icn.png") no-repeat 10px center',
    color: '#41370C',
    borderRadius: '3px',
    padding: '15px 15px 15px 35px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '964px',
    fontSize: '12px',
  },
  logoContainer: {
    padding: theme.spacing(1),
  },
  titleContainer: {
    background: '#FFFFFF url("https://my.eagleview.com/portals/0/skins/eagleview/assets/img/sectionheader.jpg") no-repeat 50% 0px',
    color: '#FFFFFF',
    padding: '25px',
    marginBottom: '30px',
  },
  title: {
    margin: '0 auto',
    padding: '0',
    fontSize: '60px',
    lineHeight: '70px',
    width: '964px',
  },
  formContainer: {
    display: 'flex',
    padding: '24px 48px 0px 48px',
    '@media (max-width:675px)': { padding: '24px 24px 100px 24px !important' },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '48px',
    alignSelf: 'stretch',
    borderTop: '1px solid #C8CDD7',
  },
  formMainContainer: {
    display: 'flex',
    maxWidth: '509px !important',
    padding: '24px 0px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    overflow: 'scroll',
    '@media (max-width:675px)': {
      width: '100%',
      padding: '0px',
      gap: '0px',
      minHeight: '95vh',
    },
    position: 'relative',
    minHeight: '100%',
    height: '100%',
    background: '#FFF',
  },
  evLogoContainer: {
    display: 'flex',
    padding: '16px 48px',
    '@media (max-width:675px)': {
      padding: '24px',
    },
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
  },
  createButtonContainer: {
    width: '964px',
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: '10px 0',
  },
  createButton: {
    color: '#fff',
    backgroundColor: '#24b5ea',
    boxShadow: '0 1px 5px #48c2dd',
    '&:hover': {
      backgroundColor: '#24bef8',
    },
  },
  formHeader: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '30px',
    textTransform: 'none',
  },
  titleHeader: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '42px',
  },
  input: {
    backgroundColor: '#FFFFFF',
    width: '170px',
    height: '25px',
    borderRadius: 0,
    fontSize: '14px',
    marginLeft: '10px',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  industryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    width: '208px',
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    alignSelf: 'stretch',
  },
  checkbox: {
    display: 'flex',
    padding: '8px 0px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
  },
  divider: { margin: '15px 0' },
  image: {
    width: '100%',
    position: 'relative',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    background: 'url(/assets/images/evbackground.jpg)',
    backgroundSize: 'cover',
  },
  logo: {
    width: '239px',
    height: 'auto',
    '@media (min-width:675px) and (max-width:1024px)': {
      display: 'flex',
      alignItems: 'center',
    },
    '@media (max-width:675px)': {
      width: '152px',
    },
  },
  checkBoxLabel: {
    color: '#000',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px', /* 128.571% */
  },
  termsText: {
    color: '#000',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px', /* 128.571% */
  },
  customerText: {
    color: '#4D5365',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  termsLink: {
    color: '#007CAD',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
  },
  aboutUsLabel: {
    color: '#1B202C',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  button: {
    '@media (max-width:675px)': {
      width: '100%',
    },
    textTransform: 'none',
    shadow: 'none',
    boxShadow: 'none',
  },
}));
